import React from 'react';
import { useRoutes } from 'react-router-dom';
import { HomePage } from './pages/Home';
import { ParceirosPage } from './pages/Parceiros';
import { CadastroParceiroPage } from './pages/CadastroParceiro';
import { ClientesPage } from './pages/Clientes';
import { RegisterProvider } from './context/RegisterContext';

const AppRoutes: React.FC = () => {
  const routes = useRoutes([
    { path: '/', element: <HomePage /> },
    { path: '/parceiros', element: <ParceirosPage /> },
    {
      path: '/cadastro-parceiro',
      element: (
        <RegisterProvider>
          <CadastroParceiroPage />
        </RegisterProvider>
      ),
    },
    { path: '/clientes', element: <ClientesPage /> },
  ]);

  return routes;
};

export default AppRoutes;
